import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../helpers/apiClient.helper';
import { worldCupQueryKeys } from '../constants/worldcupQueryKeys';
import {
  GC_TIME_WORLD_CUP_MS,
  STALE_TIME_WORLD_CUP_MATCHES_MS,
} from '../constants/worldcupReactQuery.constants';
import type { WorldCupTournamentStandingsApiPayload } from '../types/worldCupTournamentStandings.types';

export function useWorldCupTournamentStandingsQuery(
  competitionId: string,
  enabled: boolean = true,
) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: worldCupQueryKeys.standings(competitionId),
    queryFn: async () => {
      const response = await apiClient<WorldCupTournamentStandingsApiPayload>(
        `/competitions/${competitionId}/tournament-standings`,
      );
      const payload = response.data;
      if (!payload.success) {
        throw new Error(payload.error || 'Failed to fetch tournament standings');
      }
      return payload.data;
    },
    enabled,
    staleTime: STALE_TIME_WORLD_CUP_MATCHES_MS,
    gcTime: GC_TIME_WORLD_CUP_MS,
    refetchOnWindowFocus: false,
  });
}
